import React, { useState, useCallback } from 'react';
import { Box } from '@mui/material';
import SaveModal from './SaveModal';
import FetchSaved from './FetchSaved';

export interface LoadSavedHandle {
  openSave: () => void;
  openLoad: () => void;
}

interface LoadSavedProps {
  children?: (handle: LoadSavedHandle) => React.ReactNode;
}

const LoadSaved: React.FC<LoadSavedProps> = ({ children }) => {
  const [saveOpen, setSaveOpen] = useState(false);
  const [loadOpen, setLoadOpen] = useState(false);

  const openSave = useCallback(() => {
    setSaveOpen(true);
  }, []);

  const openLoad = useCallback(() => {
    setLoadOpen(true);
  }, []);

  const closeSave = useCallback(() => {
    setSaveOpen(false);
  }, []);

  const closeLoad = useCallback(() => {
    setLoadOpen(false);
  }, []);

  return (
    <Box>
      {children && children({ openSave, openLoad })}

      <SaveModal open={saveOpen} onClose={closeSave} />
      <FetchSaved open={loadOpen} onClose={closeLoad} />
    </Box>
  );
};

export default LoadSaved;
